import { render, staticRenderFns } from "./RoleAdd.vue?vue&type=template&id=01fbded6&scoped=true"
import script from "./RoleAdd.vue?vue&type=script&lang=js"
export * from "./RoleAdd.vue?vue&type=script&lang=js"
import style0 from "./RoleAdd.vue?vue&type=style&index=0&id=01fbded6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fbded6",
  null
  
)

export default component.exports